export function findAllNodesByPropertyValue(propertyName, propertyValue, root, foundNodes = []) {
    if (root instanceof Array) {
        for (const node of root) {
            foundNodes.push(...findAllNodesByPropertyValue(propertyName, propertyValue, node))
        }
    } else if (root instanceof Object) {
        if (root[propertyName] === propertyValue) {
            foundNodes.push(root)
        } else if (root.hasChildren && root.children?.length) {
            foundNodes.push(...findAllNodesByPropertyValue(propertyName, propertyValue, root.children))
        }
    }
    return foundNodes
}

export function findNodeByPropertyValue(propertyName, propertyValue, root) {
    const foundNodes = findAllNodesByPropertyValue(propertyName, propertyValue, root)
    if (foundNodes.length) {
        return foundNodes[0]
    }
    return null
}

export function findNodeParentByPropertyValue(propertyName, propertyValue, root, parentNode = null) {
    if (root instanceof Array) {
        for (const node of root) {
            const parent = findNodeParentByPropertyValue(propertyName, propertyValue, node, parentNode)
            if (parent != null) {
                return parent
            }
        }
    } else if (root instanceof Object) {
        if (root[propertyName] === propertyValue) {
            return parentNode
        } else if (root.hasChildren && root.children?.length) {
            return findNodeParentByPropertyValue(propertyName, propertyValue, root.children, root)
        }
    }
    return null
}
